<!-- <div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/products-download/products-download']">
    <span translate>COMMONS.PRODUCTS</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/products-download/product-viewer']" [queryParams]="{ productKey: productKey }">
    <span translate>{{ productKey[0] + productKey.slice(1, 4).toLowerCase() + productKey[4] + productKey.slice(5).toLowerCase() }}</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>PRODUCTS.AVTABLE</span>
</div>
<tb-header parentPage="productsviewerallreleases"></tb-header>
 -->
<div *ngIf="!isLoading">
    <div style="display: flex; justify-content: center; flex-wrap: wrap;">
            <mat-card class="fuse-card-grid" style="margin: 0 !important; width: 100%;">
              <mat-card-header>
                  <mat-card-title translate><span translate>PRODUCTS.AVTABLE</span>: {{ getProductDescription() }}</mat-card-title>
              </mat-card-header>
              <div class="table-style" *ngIf="!noReleases()">
                <table mat-table [dataSource]="productReleasesTable" multiTemplateDataRows matSort >
									<ng-container matColumnDef="version">
										<th mat-header-cell *matHeaderCellDef>Versione</th>
										<td mat-cell *matCellDef="let element">
                      <a class="version-link" (click)="openRelease(element)">{{element.ReleaseNr}} </a>
                    </td>
									</ng-container>
									<ng-container matColumnDef="type">
										<th mat-header-cell *matHeaderCellDef>Tipo</th>
										<td mat-cell *matCellDef="let element"> {{ element.ReleaseNumber.IsHotfix ? 'Hot Fix' : '' }} </td>
									</ng-container>
									<ng-container matColumnDef="pubblicationDate">
										<th mat-header-cell *matHeaderCellDef>Data pubblicazione</th>
										<td mat-cell *matCellDef="let element"> {{ getDate(element.PublicationDate) }} </td>
									</ng-container>
									<ng-container matColumnDef="fileName">
										<th mat-header-cell *matHeaderCellDef>Nome del file</th>
										<td mat-cell *matCellDef="let element"> {{getFileName(element.PublishedFileName)}} </td>
									</ng-container>
									<ng-container matColumnDef="size">
										<th mat-header-cell *matHeaderCellDef>Dimensioni</th>
										<td mat-cell *matCellDef="let element"> {{(element.PublishedFileSize / 1048576).toFixed(2)}} MB</td>
									</ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
                </table>
                <mat-paginator #releasespaginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
              </div>
              <div class="message-box warning" *ngIf="noReleases()">
                <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
              </div>
            </mat-card>
    </div>
</div>

<div *ngIf="isLoading || downloadLoading">
  <tb-loading></tb-loading>
</div>
